module.exports = __webpack_public_path__ + "assets/08713c7b0cfdc85c4734c48d9d1dd2da.png";